import https from '../init/https';

//BOOK-01 : Check real time availability of the solts
export async function tripAvaFun(data) {
    const result = await https.post(`/booking/trip/check-availability`, data);
    return result;
}

//BOOK-02 : Reserve the number of slots for 10 mins to complete a payment.
export async function tripReserveFun(data, type) {
    const result = await https.post(`/booking/${type}/reserve`, data);
    return result;
}

//BOOK-03 : Booking for trip
export async function tripBookingFun(data) {
    const result = await https.post(`/booking/trip`, data);
    return result;
}

//BOOK-13 : Trip reserve for guest
export async function tripReserveGuestFun(data, type) {
    const result = await https.post(`/booking/${type}/reserve/guest`, data);
    return result;
}

//BOOK-14 : Trip booking for guest
export async function tripBookingGuestFun(data) {
    const result = await https.post(`/booking/trip/guest`, data);
    return result;
}

//BOOK-15 - Create orderId for razor pay
export async function createOrderId(data) {
    const result = await https.post(`/booking/order/id`, data);
    return result;
}

//BOOK-04 : Check real time availability of the solts
export async function ayurAvaFun(data) {
    const result = await https.post(`/booking/ayur/check-availability`, data);
    return result;
}

//BOOK-05 : Reserve the number of slots for 10 mins to complete a payment.
export async function ayurReserveFun(data) {
    const result = await https.post(`/booking/ayur/reserve`, data);
    return result;
}

//BOOK-06 : Booking for ayur
export async function ayurBookingFun(data) {
    const result = await https.post(`/booking/ayur`, data);
    return result;
}

//BOOK-07 : Check real time availability of the solts
export async function guidAvaFun(data) {
    const result = await https.post(`/booking/guid/check-availability`, data);
    return result;
}

//BOOK-08 : Reserve the number of slots for 10 mins to complete a payment.
export async function guidReserveFun(data) {
    const result = await https.post(`/booking/guid/reserve`, data);
    return result;
}

//BOOK-09 : Booking for guid
export async function guidBookingFun(data) {
    const result = await https.post(`/booking/guid`, data);
    return result;
}

//BOOK-11 : Reserve a camp / stay and get the Razorpay order
// guest: true -> booking without login (lead guest's phone becomes the account)
// -> { orderId, reserveId, bookingId, amount }
export async function stayReserveFun(data, { guest = false } = {}) {
    const result = await https.post(`/booking/camp/reserve${guest ? '/guest' : ''}`, data);
    return result;
}

//BOOK-10b : Price of a stay for the review page (worked out on the server)
export async function stayQuoteFun(data) {
    const result = await https.post(`/booking/camp/quote`, data);
    return result;
}

//BOOK-23 : v2 trip price for the review page (offer code / coins checked on the server)
// data: { packId, packDateId, seats, rooms, transport, startCity, pickupLocation,
//         vehicleType, vehicleModel, emptySeats, comfortable, isReserved, offerCode, wallet }
export async function tripQuoteV2Fun(data) {
    const result = await https.post(`/booking/v2/trip/quote`, data);
    return result;
}

//BOOK-24/25 : v2 trip reserve at the server's price -> { orderId, reserveId, bookingId, amount }
// guest: true -> booking without login (lead traveller's phone becomes the account)
export async function tripReserveV2Fun(data, { guest = false } = {}) {
    const result = await https.post(`/booking/v2/trip/reserve${guest ? '/guest' : ''}`, data);
    return result;
}

//BOOK-26..31 : v2 activity / guide — price (offer code / coins checked on the server)
// and reserve at the server's price.  type: 'act' | 'gu'
export async function slotQuoteV2Fun(type, data) {
    const result = await https.post(`/booking/v2/${type}/quote`, data);
    return result;
}

// -> { orderId, reserveId, bookingId, amount }; guest: lead traveller's phone becomes the account
export async function slotReserveV2Fun(type, data, { guest = false } = {}) {
    const result = await https.post(`/booking/v2/${type}/reserve${guest ? '/guest' : ''}`, data);
    return result;
}

//BOOK-32 : v2 payment status + confirmation details (amounts as saved on the booking)
// -> { status, type, bookingId, ...(paid: listing, details, travellers, contact, amounts) }
export async function bookingConfirmationV2Fun(type, bookingId) {
    const result = await https.get(`/booking/v2/confirmation/${type}/${bookingId}`);
    return result;
}

//BOOK-10 : Check real time availability of the camp rooms
export async function campAvaFun(data) {
    const result = await https.post(`/booking/camp/check-availability`, data);
    return result;
}

//BOOK-11 : Reserve the camp room for the dates for 10 min to complete the payment
export async function campReserveFun(data) {
    const result = await https.post(`/booking/camp/reserve`, data);
    return result;
}

//BOOK-12 : Booking for camp
export async function campBookingFun(data) {
    const result = await https.post(`/booking/camp`, data);
    return result;
}

//BOOK-16 : Booking for custom date trips
export async function tripBookingCustomUserFun(data) {
    const result = await https.post(`/booking/trip/custom/book/user`, data);
    return result;
}

//BOOK-16 : Booking for custom date trips
export async function tripBookingCustomGuestFun(data) {
    const result = await https.post(`/booking/trip/custom/book/guest`, data);
    return result;
}

//BOOK-18 : Booking status check
export async function bookingStatus(type, id) {
    const result = await https.get(`/booking/check/payment/status/booking/${type}/${id}`);
    return result;
}

//BOOK-18 : Booking status check
export async function dateAva(data, type) {
    const result = await https.post(`/booking/${type}/check-availability`, data);
    return result;
}
